import { Component, ElementRef, Input, OnChanges, SimpleChanges, inject, numberAttribute } from '@angular/core';
import icons from './icons';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'split-icon',
  templateUrl: './split-icon.component.html',
  styleUrls: ['./split-icon.component.scss'],
  host: {
    'class': 'icon',
    '[class.is-loaded]': 'loaded'
  }
})
export class SplitIconComponent implements OnChanges {
  private _elementRef = inject(ElementRef);
  private _domSanitizer = inject(DomSanitizer);


  @Input() classes: any;
  @Input()
  name!: string;

  @Input({ transform: numberAttribute })
  set size(size: number) {
    this._elementRef.nativeElement.style.setProperty('--icon-svg-size', size + 'px');
  }


  path: any;
  loaded = false;

  private _viewBoxWidth = 0;
  private _viewBoxHeight = 0;

  get viewBox() {
    return `0 0 ${this._viewBoxWidth} ${this._viewBoxHeight}`
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['name'] && changes['name'].currentValue !== changes['name'].previousValue) {
      this._loadIcon();
    }
  }

  private _loadIcon() {
    this.loaded = false;
    let icon = icons[this.name as keyof typeof icons] 
    this.path = this._domSanitizer.bypassSecurityTrustHtml(icon);
    
    /*loadIcon(this.name)
      .then(data => {
        this.path = data.body;

        this._viewBoxWidth = data.width;
        this._viewBoxHeight = data.height;
        this.loaded = true;
      })
    ;*/
  }
}
